/**
 * Confirmation dialog shown by ProposalForm when preflight validation produces
 * WARNING-only issues (no BLOCKING errors). Lets the cataloger inspect the
 * warnings and either go back to fix them or proceed with the save anyway
 * (TASK-159 / AV-01 — UC AV-01 step 3 / AR-01 alternative path A2).
 *
 * Pure presentational — caller controls open/close state and the actual save
 * mutation (this component just hands back the user's choice through
 * `onConfirm` / `onCancel`).
 */
import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { Modal, Button } from '@folio/stripes/components';
import { ValidationIssueList } from './ValidationIssueList';
import { SaveButtonLabel, SaveInFlightAnnouncement } from '../SaveInFlight/SaveInFlight';
export var WarningModal = function (_a) {
    var warnings = _a.warnings, open = _a.open, onCancel = _a.onCancel, onConfirm = _a.onConfirm, confirmLabelId = _a.confirmLabelId, cancelLabelId = _a.cancelLabelId, _b = _a.confirmInFlight, confirmInFlight = _b === void 0 ? false : _b, describeLocation = _a.describeLocation;
    var intl = useIntl();
    var footer = (React.createElement("div", { style: { display: 'flex', justifyContent: 'flex-end', gap: '8px' } },
        React.createElement(Button, { onClick: onCancel, disabled: confirmInFlight, "data-test-warning-modal-cancel": true },
            React.createElement(FormattedMessage, { id: cancelLabelId !== null && cancelLabelId !== void 0 ? cancelLabelId : 'ui-czna-authorities.validation.modal.cancel' })),
        React.createElement(Button, { buttonStyle: "primary", onClick: onConfirm, disabled: confirmInFlight, "aria-busy": confirmInFlight, "data-test-warning-modal-confirm": true },
            React.createElement(SaveButtonLabel, { saving: confirmInFlight, labelId: confirmLabelId !== null && confirmLabelId !== void 0 ? confirmLabelId : 'ui-czna-authorities.validation.modal.confirm' })),
        React.createElement(SaveInFlightAnnouncement, { saving: confirmInFlight })));
    return (React.createElement(Modal, { open: open, label: intl.formatMessage({ id: 'ui-czna-authorities.validation.modal.heading' }, { count: warnings.length }), footer: footer, dismissible: true, onClose: function () { if (!confirmInFlight)
            onCancel(); }, size: "medium" },
        React.createElement("p", null,
            React.createElement(FormattedMessage, { id: "ui-czna-authorities.validation.modal.intro", values: { count: warnings.length } })),
        React.createElement(ValidationIssueList, { issues: warnings, describeLocation: describeLocation })));
};
export default WarningModal;
